module.exports = __webpack_public_path__ + "static/img/gaozhonghuaxue2.797d69bc.jpg";